var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogospc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 592.8 540.9",
    style: {
      enableBackground: "new 0 0 592.8 540.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#017129;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.9,310.9C45.5,326,68,338.7,96.4,338.7c24.1,0,35.8-11.4,35.8-23.2c0-15.4-17.9-20.7-41.7-26.3 c-33.7-7.7-76.9-17-76.9-63c0-34.3,29.6-62.1,78.1-62.1c32.7,0,59.9,9.9,80.3,28.7l-24.4,32.1c-16.7-15.4-38.9-22.5-59-22.5 c-19.8,0-30.3,8.6-30.3,21c0,13.9,17.3,18.2,41.1,23.8c34,7.7,77.2,17.9,77.2,63.6c0,37.7-26.9,66.1-82.5,66.1 c-39.5,0-67.9-13.3-87.4-32.7L30.9,310.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M206.4,373.3v-206h96.4c44.8,0,69.2,30.3,69.2,66.4c0,35.8-24.7,65.8-69.2,65.8h-52.5v73.8H206.4z M296.8,205 h-46.6v56.8h46.6c17.3,0,30.3-11.1,30.3-28.4C327.1,216.4,314.1,205,296.8,205z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M389.2,270.5c0-63.3,47.9-106.5,108.1-106.5c46.9,0,73.2,24.7,87.7,50.3l-37.7,18.5c-8.6-16.7-27.2-30-50-30 c-35.8,0-63,28.7-63,67.6c0,38.9,27.2,67.6,63,67.6c22.9,0,41.4-13,50-30l37.7,18.2C570.2,352,544.2,377,497.3,377 C437,377,389.2,333.8,389.2,270.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogospc);
export default __webpack_public_path__ + "static/media/logospc.aa5a0fa9870b3261a91423cfb754301a.svg";
export { ForwardRef as ReactComponent };